import React, { useState, useEffect } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';
import { IconContext } from 'react-icons/lib';
import { Button } from '../../../FixedStyled';
import {
  Nav,
  NavbarContainer,
  NavLogo,
  NavIcon,
  MobileIcon,
  NavMenu,
  NavItem,
  NavItemBtn,
  NavLinks,
  NavBtnLink,
  Extra,
} from './Nabbarstyle';

import {authentication} from "../../../firebase-config";
import { signInWithPopup , GoogleAuthProvider } from "firebase/auth";

function Navbar() {


  const googlesignin = () =>{
    const provider = new GoogleAuthProvider();
    signInWithPopup(authentication,provider)
    .then((re) => {
      console.log(re);
    })
    .catch((err) => {
      console.log(err);
    })
  }
  const [click, setClick] = useState(false);
  const [button, setButton] = useState(true);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  const showButton = () => {
    if (window.innerWidth <= 960) {
      setButton(false);
    } else {
      setButton(true);
    }
  };

  useEffect(() => {
    showButton();
  }, []);

  window.addEventListener('resize', showButton);

  return (
    <>
      <IconContext.Provider value={{ color: '#fff' }}>
        <Nav>
          <NavbarContainer>
            <NavLogo to='/' onClick={closeMobileMenu}>
              Kare 
              <Extra>
                 oss
              </Extra>
            </NavLogo>
            <MobileIcon onClick={handleClick}>
              {click ? <FaTimes style={{color: 'black'}} /> : <FaBars style={{color:'black'}}/>}
            </MobileIcon>
            <NavMenu onClick={handleClick} click={click}>
              <NavItem>
                <NavLinks to='/' onClick={closeMobileMenu}>
                  Home
                </NavLinks>
              </NavItem>
              <NavItem>
                <NavLinks to='/services' onClick={closeMobileMenu}>
                  Services
                </NavLinks>
              </NavItem>
              <NavItem>
                <NavLinks to='/aboutus' onClick={closeMobileMenu}>
                  About us
                </NavLinks>
              </NavItem>
              <NavItemBtn>
                  <NavBtnLink to='/'>
                    <Button primary outlined onClick={googlesignin} >Sign in</Button>
                  </NavBtnLink>
              </NavItemBtn>
            </NavMenu>
          </NavbarContainer>
        </Nav>
      </IconContext.Provider>
    </>
  );
}

export default Navbar;